import renderErrorModal from 'src/react_components/data-tables/render-error-modal';

const ERROR_MESSAGES = {
  401: {
    title: 'Authorisation error',
    description: `It looks like you do not have permission to make the request.
      Please contact your support team if you require further assistance.`
  },
  404: {
    title: 'Request not found',
    description: `The request you made cannot be found.
      Please ensure there aren't any typos in your URL.
      Otherwise, please contact your support team for assistance.`
  },
  408: {
    title: 'Request timeout',
    description: `The request took too long to resolve.
      Try refreshing the page. Otherwise, please contact your support team for assistance.`
  },
  429: {
    title: 'Too many requests',
    description: `We've received a lot of page requests from you in a short period.
      To prevent accidental misuse of the service we have temporarily limited access.
      Please wait a minute then try refresh the page. If this continues please let us know.`
  }
};

const DEFAULT_ERROR_MESSAGE = {
  title: 'Unexpected error',
  description: 'There was an unexpected error. Please contact your support team for assistance.'
};

const UseDataTable = (el, attributes) => el.DataTable({
  ...attributes,
  ajax: attributes.ajax && {
    ...attributes.ajax,
    error(error) {
      $('.dataTables_processing').hide();

      const message = ERROR_MESSAGES[error.status] || DEFAULT_ERROR_MESSAGE;
      renderErrorModal({ message });
    }
  }
});

export default UseDataTable;
